import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import Section, { Container, Row, Col } from '../../../../components/ui/wrapper'
import Heading from '../../../../components/ui/heading'
import Button from '../../../../components/ui/button'

const CTASection = ({
    sectionStyle,
    heading,
    text,
    ButtonOne,
    ButtonTwo,
    headingText,
    letsTalkLink,
    infoLink,
    ...props
}) => {
    const ctaData = useStaticQuery(graphql`
        query CtaImgQuery {
            file(relativePath: {eq: "images/bg/cta-bg-2.png"}) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, quality: 70)
                }
            }
        }
    `);
    const imageData = ctaData.file.childImageSharp.gatsbyImageData;
    return (
        <Section {...sectionStyle} bgImage={imageData}>
            <Container>
                <Row className="align-items-center text-lg-left text-center">
                    <Col xl={8} lg={7}>
                        <Heading {...heading} dangerouslySetInnerHTML={{ __html: headingText }} />
                    </Col>
                    <Col xl={4} lg={5} className="text-center">
                        {letsTalkLink && <Button
                            to={letsTalkLink.path}
                            {...ButtonOne}
                            iconname="far fa-comment-alt-dots"
                            iconposition="left"
                            iconsize="16px">
                            {letsTalkLink.label}
                        </Button>
                        }
                        {infoLink &&
                            <Button
                                to={infoLink.path}
                                {...ButtonTwo}
                                iconname="far fa-info-circle"
                                iconposition="left"
                                iconsize="16px">
                                {infoLink.label}
                            </Button>
                        }
                    </Col>
                </Row>
            </Container>
        </Section>
    )
}

CTASection.propTypes = {
    heading: PropTypes.object
}

CTASection.defaultProps = {
    sectionStyle: {
        bgColor: '#454545',
        bgsize: 'auto',
        opacity: 1,
        objectFit: 'contain',
        objectPosition: 'right',
        pt: '80px',
        pb: '80px',
        responsive: {
            medium: {
                pt: '60px',
                pb: '60px'
            },
            small: {
                pt: '40px',
                pb: '40px'
            }
        }
    },
    heading: {
        as: 'h3',
        color: '#fff',
        child: {
            color: 'secondary'
        },
        responsive: {
            medium: {
                mb: '10px'
            }
        }
    },
    ButtonOne: {
        skin: 'light',
        m: '7px'
    },
    ButtonTwo: {
        skin: 'secondary',
        m: '7px'
    }
}


export default CTASection